import React from 'react';
import './Reasons.css';
import image1 from "../../assets/image1.png";
import image2 from "../../assets/image2.png";
import image3 from "../../assets/image3.png";
import image4 from "../../assets/image4.png";
import nb from "../../assets/nb.png";
import adidas from "../../assets/adidas.png";
import nike from "../../assets/nike.png";
import tick from "../../assets/tick.png";

const Reasons = () => {
  return (
    <div className="Reasons" id="reasons">
        <div className="left-r">
            <img src={image1} alt="სურათი 1" />
            <img src={image2} alt="სურათი 2" />
            <img src={image3} alt="სურათი 3" />
            <img src={image4} alt="სურათი 4" />
        </div>

        <div className="right-r">
            <span>რამდენიმე მიზეზი</span>
            <div>
                <span className="stroke-text">რატომ</span>
                <span> უნდა აგვირჩიოთ?</span>
            </div>
            <div>
                <div className="details-r">
                    <div>
                        <img src={tick} alt="თიკი" />
                        <span>140+ პროფესიონალი მწვრთნელი</span>
                    </div>
                    <div>
                        <img src={tick} alt="თიკი" />
                        <span>ვარჯიში უფრო ჭკვიანურად და სწრაფად</span>
                    </div>
                    <div>
                        <img src={tick} alt="თიკი" />
                        <span>1 უფასო პროგრამა ახალი წევრებისთვის</span>
                    </div>
                    <div>
                        <img src={tick} alt="თიკი" />
                        <span>სანდო პარტნიორები</span>
                    </div>
                </div>
            </div>
            <span style={{
                color: 'var(--gray)',
                fontWeight: "normal"
            }}>
                ჩვენი პარტნიორები
            </span>
            <div className="partners">
                <img src={nb} alt="ნიუ ბალანსი" />
                <img src={adidas} alt="ადიდასი" />
                <img src={nike} alt="ნაიკი" />
            </div>
        </div>
    </div>
  );
}

export default Reasons;
